<template>
  <div class="my-chat-bubble">
    <div class="my-chat-bubble__content">
      <GeneralMessageChatGoingTextTarget
        v-show="isVisibleTarget"
        :is-complete="chatMessageCall.tgt.isComplete"
        :is-target-playing
        :chat-contents="chatMessageCall.tgt.contents"
        :is-interpreting="isInterpretingTgt"
        :language-code-set="chatMessageCall.tgtLanguageSet"
        :using-auto-height="usingAutoHeight"
        :is-dm-message
      />
      <div
        v-if="isVisibleSource && isVisibleTarget"
        class="divider-light"
      ></div>
      <!--TOFE : 버블안의 LanguageDetection 작업후 활성화해주세요
      <ChatLanguageDetection />
      -->
      <GeneralMessageChatGoingTextSource
        v-show="isVisibleSource"
        :is-complete="chatMessageCall.src.isComplete"
        :is-source-playing
        :chat-contents="chatMessageCall.src.contents"
        :is-pending-src
        :language-code-set="chatMessageCall.srcLanguageSet"
        :using-auto-height="usingAutoHeight"
        :is-dm-message
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import GeneralMessageChatGoingTextSource from '@/components/domains/chat/chat-general/GeneralMessageChatGoingTextSource.vue';
import GeneralMessageChatGoingTextTarget from '@/components/domains/chat/chat-general/GeneralMessageChatGoingTextTarget.vue';
import { ChatMessage } from '@/types/socket';
// import ChatLanguageDetection from '@/components/domains/chat/chat-general/ChatLanguageDetection.vue';

const props = withDefaults(
  defineProps<{
    chatMessageCall: ChatMessage;
    isTargetPlaying: boolean;
    isSourcePlaying: boolean;
    isVisibleSource: boolean;
    isVisibleTarget: boolean;
    usingAutoHeight?: boolean;
    isDmMessage: boolean;
  }>(),
  {
    chatContents: () => [],
    isSourcePlaying: false,
    isTargetPlaying: false,
    isVisibleSource: false,
    isVisibleTarget: false,
    usingAutoHeight: true,
    isDmMessage: false,
  }
);

const isPendingSrc = computed(() => {
  return (
    props.chatMessageCall.reset === '0' &&
    (!Array.isArray(props.chatMessageCall.src.contents) ||
      props.chatMessageCall.src.contents.length === 0)
  );
});

const isInterpretingTgt = computed(() => {
  return (
    props.chatMessageCall.reset === '0' &&
    (!Array.isArray(props.chatMessageCall.tgt.contents) ||
      props.chatMessageCall.tgt.contents.length === 0)
  );
});
</script>

<style scoped lang="scss">
.my-chat-bubble {
  align-items: flex-start;
  padding: 0.75rem 1rem;
  border-radius: 12px 12px 2px 12px;
  background: var(--background-chat-my);
  width: calc(100% - 4rem);
  margin-left: 0.5rem;
  flex-shrink: 0;
  transition:
    opacity 0.4s ease,
    transform 0.4s ease;
}

.my-chat-bubble__content {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  width: 100%;
}

.divider-light {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

@media (min-width: 768px) {
  .my-chat-bubble {
    min-width: 70%;
    max-width: 70%;
  }
}
</style>
